import { useState } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function AdminLogin() {
  const { user, isAdmin, loading, adminLogin } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="w-8 h-8 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (user || isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    const ok = adminLogin(password);

    if (!ok) {
      setError('Incorrect password. Please try again.');
    }

    setSubmitting(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="w-full max-w-[400px]">
        <div className="text-center mb-8">
          <Link to="/" className="inline-block">
            <h1 className="font-heading text-foreground-900 text-xl tracking-wide">
              CAROL L BERRY
            </h1>
            <p className="font-body text-foreground-500 text-xs tracking-widest uppercase mt-1">
              Blog Administration
            </p>
          </Link>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-lg p-6">
          <h2 className="font-heading text-foreground-900 text-lg mb-6">Admin Access</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <label htmlFor="password" className="block text-foreground-700 font-body text-sm mb-1.5">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoFocus
                className="w-full border border-background-300 rounded-md px-3 py-2.5 text-sm font-body text-foreground-900 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent bg-background-50"
                placeholder="Enter admin password"
              />
            </div>
            {error && (
              <div className="mb-4 p-3 rounded-md bg-red-50 border border-red-200">
                <p className="text-red-700 font-body text-xs">{error}</p>
              </div>
            )}
            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-primary-500 text-background-50 px-4 py-2.5 rounded-md text-sm font-body font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {submitting && <div className="w-4 h-4 border-2 border-background-50 border-t-transparent rounded-full animate-spin" />}
              Sign In
            </button>
          </form>
        </div>

        <p className="text-center mt-6">
          <Link to="/" className="text-foreground-500 font-body text-xs hover:text-foreground-700 transition-colors">
            <i className="ri-arrow-left-line mr-1" />Return to Website
          </Link>
        </p>
      </div>
    </div>
  );
}